import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    SyncTrierCustomers(erpId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    syncTrierCustomers (
                        id: ${erpId}
                    )
                }
            `
        })
    }
}